import { render, staticRenderFns } from "./dbTableData.vue?vue&type=template&id=4120aee9&scoped=true&"
import script from "./dbTableData.vue?vue&type=script&lang=js&"
export * from "./dbTableData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4120aee9",
  null
  
)

export default component.exports